import { Box, Typography } from "@mui/material";
import { ModernCard } from "../shared/ModernCard";
import { ModernInfoItem } from "../shared/ModernInfoItem";
import { useProducerInternalData } from "../../hooks/useProducerInternalData";

export const TabContaCorrente = () => {
  const { metrics } = useProducerInternalData();

  return (
    <ModernCard title="Conta Corrente">
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
        <ModernInfoItem label="Saldo atual" value={metrics.saldoContaCorrente} />
        <ModernInfoItem label="Status" value={metrics.statusSaldo} />
      </Box>
      <Typography variant="caption" sx={{ color: "text.secondary", mt: 1, display: "block" }}>
        Para lancamentos detalhados, utilize a tela de Conta Corrente com filtros.
      </Typography>
    </ModernCard>
  );
};
